<div class="position-relative" [ngClass]="cssClass">
  <div
    class="shape-divider shape-divider-bottom shape-divider-fluid-x text-{{
      shapeCssText
    }}"
  >
    <svg viewBox="0 0 2880 48" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"></path>
    </svg>
  </div>
</div>
